module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAIVBMVEUAAAAlJS4gIDAmJC4mJC4mJS4mJS4mJi0mJC4nIy4mJS4+UfNcAAAACnRSTlMA7xCAf+viUOdIvgDP2wAAAJZJREFUOMvtz7EJgDAQhWHJCgpilxUsHMDCCXQKOzs3EOxcQuSmNEQfZ3zpRLAwRQj/B+EueXJM09lor0UyG+8Q7l64p6UX7tZAwu7CKdRVbl2F+lUG7Sq5e8zaVbYDePb1+Ipnz5PXZtceCnVI2MfOQtBNM7m7lwyCXsvqAaLdwyKQqkWX4t/8c5tfBJ0EnSTWsfmDswMk8smbYQhfWQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/layers_pre.png
// module id = fUeL
// module chunks = 44